import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {NotificationMessage} from "../../services/models/notifications/NotificationMessage";
import {IonSlides, NavController} from "@ionic/angular";

@Component({
  selector: 'app-notification-popup',
  templateUrl: './notification-popup.component.html',
  styleUrls: ['./notification-popup.component.scss'],
})
export class NotificationPopupComponent implements OnInit {
  @Input()notifications!: NotificationMessage[];
  @Input()isVisible = false;
  @Output()action = new EventEmitter();
  @ViewChild('slider') slider!: IonSlides;

  constructor(
    private navCtrl: NavController,
    private detector: ChangeDetectorRef
  ) { }

  public showMessage(messages: NotificationMessage[]) {
    this.notifications = messages;
    this.isVisible = true;
    this.detector.detectChanges();
    console.log(this.notifications);
  }
  arrowLeft_click() {
    this.slider.slidePrev();
  }
  arrowRight_click() {
    this.slider.slideNext();
  }
  onClose_click() {
    this.isVisible = false;
    this.detector.detectChanges();
  }
  async onBanner_click(href: string, isActive: boolean) {
    if (isActive) {
      await this.onButton_click(href);
    }
  }
  async onButton_click(href: string) {
    console.log(href);
    this.detector.detectChanges();
    if (href) {
      await this.navCtrl.navigateForward(href);
      this.onClose_click();
    } else {
      this.onClose_click();
    }
  }
  ngOnInit() {}
}
